import { GET } from './api'

export const Read = async () => {
    return await GET(`/vw-lista-cotistas?_limit=-1`, true, true);
}
